import {
  INTERNAL_PROJECTS_LIST_LOADING,
  INTERNAL_PROJECTS_LIST_SUCCESS,
  INTERNAL_PROJECTS_LIST_FAILURE,
} from "redux/types";

const initialState = {
  internalProjectsLoading: false,
  internalProjets: null,
  erros: null,
};

export const internalProjectsReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case INTERNAL_PROJECTS_LIST_LOADING:
      return { ...state, internalProjectsLoading: action.payload };
    case INTERNAL_PROJECTS_LIST_SUCCESS:
      return { ...state, internalProjets: action.payload };
    case INTERNAL_PROJECTS_LIST_FAILURE:
      return { ...state, errors: action.payload };
    default:
      return state;
  }
};
